import { render, staticRenderFns } from "./AppSplash.vue?vue&type=template&id=29b46ed7&scoped=true"
import script from "./AppSplash.vue?vue&type=script&lang=js"
export * from "./AppSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b46ed7",
  null
  
)

export default component.exports